<template>
  <div class="kcm-group-management">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="img-and-text img-and-text-sm">
        <div class="text-group">
          <h3 class="text-accent">{{ $t('kcm-group-management-1') }}</h3>
          <h1>{{ $t('kcm-group-executive-management-1') }}</h1>
          <br>
          <ul>
            <li
              v-for="(m, i) in managers"
              :key="`name-and-position-${i}`"
            >{{ m.name }}, {{ m.position }}</li>
          </ul>
        </div>
      </div>
      <!-- PROFILES -->
      <div class="management-profiles">
        <div
          class="management-profile"
          v-for="(m, i) in managers"
          :key="`manager-${i}`"
          @click="isModalOpened = true, selected = i"
        >
          <img :src="m.img" :alt="m.name">
          <h2 class="strong">{{ m.name }}</h2>
          <span>{{ m.position }}</span>
        </div>
      </div>
    </div>
    <CompaniesList/>
    <transition name="fade">
      <ManagementModal v-if="isModalOpened" :content="managers[selected]"/>
    </transition>
  </div>
</template>

<script>
import ManagementModal from './ManagementModal';
import CompaniesList from './CompaniesList';
export default {
  components: {
    ManagementModal,
    CompaniesList
  },
  watch: {
    // whenever active changes, this function will run
    isModalOpened() {
      document.body.style.overflow = this.isModalOpened ? 'hidden' : '';
    }
  },
  data() {
    return {
      isModalOpened: false,
      selected: 0
    };
  },
  computed: {
    managers() {
      return [
        // Румен Цонев
        {
          img: require('../../assets/img/kcm_group/management/tsonev.jpg'),
          name: this.$t('kcm-group-management-tsonev-name'),
          position: this.$t('kcm-group-management-tsonev-position-exec'),
          description: this.$t('kcm-group-management-tsonev-description'),
          education: this.$t('kcm-group-management-tsonev-education'),
          experience: this.$t('kcm-group-management-tsonev-experience')
        },
        // Розин Ангелов
        {
          img: require('../../assets/img/kcm_group/management/angelov.jpg'),
          name: this.$t('kcm-group-management-angelov-name'),
          position: this.$t('kcm-group-management-angelov-position-exec'),
          description: this.$t('kcm-group-management-angelov-description'),
          education: this.$t('kcm-group-management-angelov-education'),
          experience: this.$t('kcm-group-management-angelov-experience')
        },
        // Стоян Пехливанов
        {
          img: require('../../assets/img/kcm_group/management/s_pehlivanov.jpg'),
          name: this.$t('kcm-group-management-pehlivanov-name'),
          position: this.$t('kcm-group-management-pehlivanov-position-exec'),
          description: this.$t('kcm-group-management-pehlivanov-description'),
          // list: this.$t('kcm-group-management-pehlivanov-list'),
          education: this.$t('kcm-group-management-pehlivanov-education'),
          experience: this.$t('kcm-group-management-pehlivanov-experience')
        },
        // Мариана Гуркопашова
        {
          img: require('../../assets/img/kcm_group/management/gurkopashova.jpg'),
          name: this.$t('kcm-group-management-gurkopashova-name'),
          position: this.$t('kcm-group-management-gurkopashova-position-exec'),
          description: this.$t('kcm-group-management-gurkopashova-description'),
          education: this.$t('kcm-group-management-gurkopashova-education'),
          experience: this.$t('kcm-group-management-gurkopashova-experience')
        }
      ];
    }
  },
  mounted() {
    this.$on('close-modal', () => {
      this.isModalOpened = false;
    });
  },
  destroyed() {
    this.$off('close-modal');
  }
};
</script>

<style lang="scss" scoped>
.kcm-group-management {
  position: relative;
  .decoration-element {
    width: 80%;
  }
  .row-1 {
    .img-and-text-sm {
      width: 47%;
    }
    .text-group {
      margin-top: 0;
    }
  }
  .management-profiles {
    display: flex;
    justify-content: space-between;
    padding-left: $sidesPadding / 2;
    padding-right: $sidesPadding / 2;
    position: relative;
    width: 53%;
    .management-profile {
      cursor: pointer;
      @include transition(all 0.3s);
      width: 24%;
      position: relative;
      img {
        display: block;
        height: auto;
        width: 100%;
      }
      h2 {
        margin: 15px 0 5px;
        font-size: 16px;
        @include transition(all 0.6s $mainCubic);
      }
      span {
        font-size: 12px;
        @include transition(all 0.6s $mainCubic);
      }
    }
    .management-profile::before {
      background-color: $mainColor;
      content: '';
      height: 104%;
      left: -2%;
      top: -2%;
      position: absolute;
      width: 104%;
      @include transition(all 0.6s $mainCubic);
      @include transform(scale(0));
      z-index: -1;
    }
    .management-profile:hover {
      h2,
      span {
        color: #fff;
      }
    }
    .management-profile:hover::before {
      @include transform(scale(1));
    }
  }
}
@media screen and (max-width: 1600px) {
  .kcm-group-management {
    .management-profiles {
      padding-left: $sidesPadding1600 / 2;
      padding-right: $sidesPadding1600 / 2;
    }
  }
}
@media screen and (max-width: 1376px) {
  .kcm-group-management {
    .management-profiles {
      .management-profile {
        h2 {
          margin: 10px 0 5px;
          font-size: 12px;
        }
        span {
          font-size: 9px;
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .kcm-group-management {
    .management-profiles {
      padding-left: $sidesPadding1280 / 2;
      padding-right: $sidesPadding1280 / 2;
    }
  }
}
@media screen and (max-width: 1000px) {
  .kcm-group-management {
    .row-1 {
      flex-direction: column;
      .img-and-text-sm {
        width: 100%;
        .text-group {
          padding: 0 $sidesPadding1280;
        }
      }
    }
    .management-profiles {
      padding-left: $sidesPadding1280;
      padding-right: $sidesPadding1280;
      width: 100%;
    }
  }
}
@media screen and (max-width: 600px) {
  .kcm-group-management {
    .row-1 {
      .img-and-text-sm {
        .text-group {
          padding: 0 $sidesPadding600;
        }
      }
    }
    .management-profiles {
      flex-wrap: wrap;
      padding-left: $sidesPadding600;
      padding-right: $sidesPadding600;
      width: 100%;
      .management-profile {
        margin-bottom: 15px;
        width: 48%;
      }
    }
  }
}
</style>
